import React from 'react'
import './ui.css'

function SegmentedControl ({
  options,
  value,
  onChange,
  ariaLabel,
  className = '',
  size = 'md',
}) {
  if (!options?.length) return null

  return (
    <div
      className={`ds-segmented ds-segmented-${size} ${className}`.trim()}
      role="group"
      aria-label={ariaLabel}
    >
      {options.map((option) => {
        const optionValue = option.value ?? option.id
        const active = optionValue === value
        return (
          <button
            key={optionValue}
            type="button"
            className={`ds-segmented-option${active ? ' ds-segmented-option-active' : ''}`}
            aria-pressed={active}
            onClick={() => onChange?.(optionValue)}
            disabled={option.disabled}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}

export default SegmentedControl
